/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface IArticle {
  id?: string | null;
  isActive?: boolean;
  /** @format date-time */
  publishDate?: string | Date;
  title?: string | null;
  html?: string | null;
  video?: string | null;
  picture?: string | null;
  videoCoverPicture?: string | null;
  articleCategoryID?: string | null;
  userExpertProfileID?: string | null;
  sponsorCompanyID?: string | null;
  displayForAll?: boolean;
  sponsoredByTheBio?: boolean;
  displayInLandingPage?: boolean;
  sponsorCompany?: ISponsorCompany;
  userExpertProfile?: IUserExpertProfile;
  articleCategory?: IArticleCategory;
  userExpertProfileArticles?: IUserExpertProfileArticle[] | null;
  articleComments?: IArticleComment[] | null;
  articleReactions?: IArticleReaction[] | null;
  articleTags?: IArticleTag[] | null;
  articlePictures?: IArticlePicture[] | null;
  userExpertProfileViews?: IUserExpertProfileView[] | null;
}

export interface IArticleCategory {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  icon?: string | null;
  iconSecondary?: string | null;
  /** @format int32 */
  rank?: number;
  articles?: IArticle[] | null;
}

export interface IArticleCategoryDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IArticleCategory[];
}

export interface IArticleComment {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  articleID?: string | null;
  comment?: string | null;
  article?: IArticle;
  userExpertProfile?: IUserExpertProfile;
  articleCommentReplies?: IArticleCommentReply[] | null;
}

export interface IArticleCommentDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IArticleComment[];
}

export interface IArticleCommentReply {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  articleCommentID?: string | null;
  comment?: string | null;
  articleComment?: IArticleComment;
  userExpertProfile?: IUserExpertProfile;
}

export interface IArticleCommentReplyDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IArticleCommentReply[];
}

export interface IArticleDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IArticle[];
}

export interface IArticlePicture {
  id?: string | null;
  isActive?: boolean;
  articleID?: string | null;
  linkURL?: string | null;
  picture?: string | null;
  /** @format int32 */
  rank?: number;
  article?: IArticle;
}

export interface IArticlePictureDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IArticlePicture[];
}

export interface IArticleReaction {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  articleID?: string | null;
  article?: IArticle;
  userExpertProfile?: IUserExpertProfile;
}

export interface IArticleReactionDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IArticleReaction[];
}

export interface IArticleTag {
  id?: string | null;
  isActive?: boolean;
  articleID?: string | null;
  tagID?: string | null;
  article?: IArticle;
  tag?: ITag;
}

export interface IArticleTagDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IArticleTag[];
}

export interface ICampaign {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  description?: string | null;
  filterExpertTypeID?: string | null;
  filterUserStatusID?: string | null;
  filterVirtualEventID?: string | null;
  filterMissingName?: boolean | null;
  filterSearchText?: string | null;
  bannerUrl?: string | null;
  subject?: string | null;
  body?: string | null;
  footer?: string | null;
  /** @format date-time */
  lastSentDate?: string | Date | null;
  /** @format int32 */
  totalSent?: number | null;
}

export interface ICampaignDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ICampaign[];
}

export interface IChatConversation {
  id?: string | null;
  isActive?: boolean;
  fromUserID?: string | null;
  toUserID?: string | null;
  fromUserNotRead?: boolean;
  toUserNotRead?: boolean;
  notRead?: boolean;
  fromUser?: IUserExpertProfile;
  toUser?: IUserExpertProfile;
  chatConversationMessages?: IChatConversationMessage[] | null;
}

export interface IChatConversationDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IChatConversation[];
}

export interface IChatConversationMessage {
  id?: string | null;
  isActive?: boolean;
  chatConversationID?: string | null;
  userExpertProfileID?: string | null;
  message?: string | null;
  isRead?: boolean;
  chatConversation?: IChatConversation;
  userExpertProfile?: IUserExpertProfile;
}

export interface IChatConversationMessageDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IChatConversationMessage[];
}

export interface ICity {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  userExpertProfiles?: IUserExpertProfile[] | null;
}

export interface ICityDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ICity[];
}

export interface ICloudFileViewModel {
  fileName?: string | null;
  fileStreamString?: string | null;
  filePath?: string | null;
  isImage?: boolean;
}

export interface ICommonPage {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  languageID?: string | null;
  commonPageType?: IPageType;
  html?: string | null;
  canonical?: string | null;
  metaTitle?: string | null;
  metaDescription?: string | null;
  metaKeyWords?: string | null;
  language?: ILanguage;
}

export interface ICommonPageDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ICommonPage[];
}

export interface ICurrentUserProfileResponse {
  appUserID?: string | null;
  languageID?: string | null;
  name?: string | null;
  email?: string | null;
  userPhoto?: string | null;
  userCrmProfilePermission?: IUserCrmProfilePermission;
  isActive?: boolean;
}

export interface IEmailContent {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  languageID?: string | null;
  emailKey?: string | null;
  bannerUrl?: string | null;
  subject?: string | null;
  body?: string | null;
  footer?: string | null;
  language?: ILanguage;
}

export interface IEmailContentDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IEmailContent[];
}

export interface IExpertType {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  visitor?: boolean;
  isAllowViewVirtualEvent?: boolean;
  isAllowRegisterVirtualEvent?: boolean;
  isAllowViewWebinars?: boolean;
  isAllowViewArticle?: boolean;
  isAllowPostArticle?: boolean;
  isAllowReactArticle?: boolean;
  isAllowCommentArticle?: boolean;
  isAllowViewComment?: boolean;
  isAllowViewReaction?: boolean;
  isAllowViewSurvey?: boolean;
  isAllowVoteSurvey?: boolean;
  isAllowViewUser?: boolean;
  isAllowChatUser?: boolean;
  isAllowSearchUser?: boolean;
  isAllowFollowUser?: boolean;
  isAllowRegisterToTheNetwork?: boolean;
  userExpertProfiles?: IUserExpertProfile[] | null;
}

export interface IExpertTypeDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IExpertType[];
}

export interface IFieldOfOccupation {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  isOther?: boolean;
  userExpertProfiles?: IUserExpertProfile[] | null;
}

export interface IFieldOfOccupationDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IFieldOfOccupation[];
}

export interface IGeneratePasswordRequest {
  email?: string | null;
}

export interface IGlobalParameter {
  id?: string | null;
  isActive?: boolean;
  version?: string | null;
  generalBodyScripts?: string | null;
  generalFooterScripts?: string | null;
  generalHeaderScripts?: string | null;
  googleAnalyticScripts?: string | null;
  metaTitle?: string | null;
  metaDescription?: string | null;
  metaKeyWords?: string | null;
  fullStoryCode?: string | null;
}

export interface IGlobalParameterDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IGlobalParameter[];
}

export interface IIndustry {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  image?: string | null;
  /** @format int32 */
  rank?: number;
  userExpertProfiles?: IUserExpertProfile[] | null;
}

export interface IIndustryDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IIndustry[];
}

export interface IJwt {
  token?: string | null;
  refreshToken?: string | null;
}

export interface ILabel {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  languageID?: string | null;
  labelSourceID?: string | null;
  labelKey?: string | null;
  labelSource?: ILabelSource;
  language?: ILanguage;
}

export interface ILabelDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ILabel[];
}

export interface ILabelSource {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  key?: string | null;
  labels?: ILabel[] | null;
}

export interface ILabelSourceDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ILabelSource[];
}

export interface ILanguage {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  direction?: ILanguageDirection;
  culture?: string | null;
  icon?: string | null;
  /** @format int32 */
  rank?: number;
  labels?: ILabel[] | null;
  userCrmProfiles?: IUserCrmProfile[] | null;
  userExpertProfiles?: IUserExpertProfile[] | null;
  emailContents?: IEmailContent[] | null;
  smsContents?: ISMSContent[] | null;
  commonPages?: ICommonPage[] | null;
}

export enum ILanguageDirection {
  RTL = 'RTL',
  LTR = 'LTR',
}

export interface ILanguageDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ILanguage[];
}

export interface ILoginRequest {
  email?: string | null;
  code?: string | null;
}

export interface ILoginResponse {
  jwt?: IJwt;
  /** @format date-time */
  expires?: string | Date;
}

export interface IOperation {
  operationType?: IOperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any;
}

export enum IOperationType {
  Add = 'Add',
  Remove = 'Remove',
  Replace = 'Replace',
  Move = 'Move',
  Copy = 'Copy',
  Test = 'Test',
  Invalid = 'Invalid',
}

export enum IPageType {
  Privacy = 'Privacy',
  Terms = 'Terms',
  App = 'App',
}

export interface ISMSContent {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  languageID?: string | null;
  smsKey?: string | null;
  message?: string | null;
  canUnsubscribe?: boolean;
  language?: ILanguage;
}

export interface ISMSContentDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ISMSContent[];
}

export interface ISpeakLanguage {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  /** @format int32 */
  rank?: number;
  userExpertProfileSpeakLanguages?: IUserExpertProfileSpeakLanguage[] | null;
}

export interface ISpeakLanguageDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ISpeakLanguage[];
}

export interface ISponsorCompany {
  id?: string | null;
  isActive?: boolean;
  companyName?: string | null;
  description?: string | null;
  logo?: string | null;
  visitorCode?: string | null;
  allowDemoForVisitor?: boolean;
  surveys?: ISurvey[] | null;
  articles?: IArticle[] | null;
}

export interface ISponsorCompanyDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ISponsorCompany[];
}

export interface ISurvey {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  sponsorCompanyID?: string | null;
  question?: string | null;
  description?: string | null;
  displayForAll?: boolean;
  /** @format int32 */
  rank?: number;
  sponsorCompany?: ISponsorCompany;
  surveyOptions?: ISurveyOption[] | null;
  surveyTags?: ISurveyTag[] | null;
  userExpertProfileSurveys?: IUserExpertProfileSurvey[] | null;
  userExpertProfileViews?: IUserExpertProfileView[] | null;
}

export interface ISurveyDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ISurvey[];
}

export interface ISurveyOption {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  surveyID?: string | null;
  color?: string | null;
  /** @format int32 */
  rank?: number;
  survey?: ISurvey;
  userExpertProfileSurveys?: IUserExpertProfileSurvey[] | null;
}

export interface ISurveyOptionDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ISurveyOption[];
}

export interface ISurveyTag {
  id?: string | null;
  isActive?: boolean;
  surveyID?: string | null;
  tagID?: string | null;
  survey?: ISurvey;
  tag?: ITag;
}

export interface ISurveyTagDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ISurveyTag[];
}

export interface ITag {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  /** @format int32 */
  rank?: number;
  virtualEventTags?: IVirtualEventTag[] | null;
  userExpertProfileTags?: IUserExpertProfileTag[] | null;
  surveyTags?: ISurveyTag[] | null;
  articleTags?: IArticleTag[] | null;
}

export interface ITagDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: ITag[];
}

export interface IUserCrmProfile {
  id?: string | null;
  isActive?: boolean;
  appIdentityUserID?: string | null;
  languageID?: string | null;
  /** @format date-time */
  startDate?: string | Date;
  email?: string | null;
  mobilePhone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  userPhoto?: string | null;
  language?: ILanguage;
  userCrmProfilePermissionID?: string | null;
  userCrmProfilePermission?: IUserCrmProfilePermission;
}

export interface IUserCrmProfileDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserCrmProfile[];
}

export interface IUserCrmProfilePermission {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  isAllowToEditSetting?: boolean;
  isAllowToEditLabels?: boolean;
  isAllowToEditProfile?: boolean;
  isAllowToEditCrmUsers?: boolean;
  isAllowToEditPermissions?: boolean;
  isAllowToViewLog?: boolean;
  isAllowToViewSensitiveInformation?: boolean;
  isAllowToResetSensitiveInformation?: boolean;
  userCrmProfiles?: IUserCrmProfile[] | null;
}

export interface IUserCrmProfilePermissionDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserCrmProfilePermission[];
}

export interface IUserExpertProfile {
  id?: string | null;
  isActive?: boolean;
  appIdentityUserID?: string | null;
  languageID?: string | null;
  /** @format date-time */
  startDate?: string | Date;
  email?: string | null;
  mobilePhone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  userPhoto?: string | null;
  language?: ILanguage;
  expertTypeID?: string | null;
  userExpertStatusID?: string | null;
  fieldOfOccupationID?: string | null;
  industryID?: string | null;
  cityID?: string | null;
  position?: string | null;
  fullNameEnglish?: string | null;
  description?: string | null;
  ipAddress?: string | null;
  location?: string | null;
  deviceType?: string | null;
  companyName?: string | null;
  isAllowSMS?: boolean;
  expertType?: IExpertType;
  userExpertStatus?: IUserExpertStatus;
  city?: ICity;
  industry?: IIndustry;
  fieldOfOccupation?: IFieldOfOccupation;
  articles?: IArticle[] | null;
  articleComments?: IArticleComment[] | null;
  articleCommentReplies?: IArticleCommentReply[] | null;
  articleReactions?: IArticleReaction[] | null;
  userExpertProfileViews?: IUserExpertProfileView[] | null;
  userExpertProfileArticles?: IUserExpertProfileArticle[] | null;
  followings?: IUserExpertProfileFollow[] | null;
  followers?: IUserExpertProfileFollow[] | null;
  userExpertProfileVirtualEvents?: IUserExpertProfileVirtualEvent[] | null;
  userExpertProfileTags?: IUserExpertProfileTag[] | null;
  userExpertProfileSpeakLanguages?: IUserExpertProfileSpeakLanguage[] | null;
  userExpertProfileSurveys?: IUserExpertProfileSurvey[] | null;
  fromUserConversations?: IChatConversation[] | null;
  toUserConversations?: IChatConversation[] | null;
  chatConversationMessages?: IChatConversationMessage[] | null;
}

export interface IUserExpertProfileArticle {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  articleID?: string | null;
  userExpertProfile?: IUserExpertProfile;
  article?: IArticle;
}

export interface IUserExpertProfileArticleDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfileArticle[];
}

export interface IUserExpertProfileDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfile[];
}

export interface IUserExpertProfileFollow {
  id?: string | null;
  isActive?: boolean;
  currentUserExpertProfileID?: string | null;
  followUserExpertProfileID?: string | null;
  currentUserExpertProfile?: IUserExpertProfile;
  followUserExpertProfile?: IUserExpertProfile;
}

export interface IUserExpertProfileFollowDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfileFollow[];
}

export interface IUserExpertProfileSpeakLanguage {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  speakLanguageID?: string | null;
  userExpertProfile?: IUserExpertProfile;
  speakLanguage?: ISpeakLanguage;
}

export interface IUserExpertProfileSpeakLanguageDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfileSpeakLanguage[];
}

export interface IUserExpertProfileSurvey {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  surveyID?: string | null;
  surveyOptionID?: string | null;
  userExpertProfile?: IUserExpertProfile;
  survey?: ISurvey;
  surveyOption?: ISurveyOption;
}

export interface IUserExpertProfileSurveyDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfileSurvey[];
}

export interface IUserExpertProfileTag {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  tagID?: string | null;
  userExpertProfile?: IUserExpertProfile;
  tag?: ITag;
}

export interface IUserExpertProfileTagDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfileTag[];
}

export interface IUserExpertProfileView {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  virtualEventID?: string | null;
  articleID?: string | null;
  surveyID?: string | null;
  playVideo?: boolean;
  survey?: ISurvey;
  article?: IArticle;
  virtualEvent?: IVirtualEvent;
  userExpertProfile?: IUserExpertProfile;
}

export interface IUserExpertProfileViewDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfileView[];
}

export interface IUserExpertProfileVirtualEvent {
  id?: string | null;
  isActive?: boolean;
  userExpertProfileID?: string | null;
  virtualEventID?: string | null;
  userExpertProfile?: IUserExpertProfile;
  virtualEvent?: IVirtualEvent;
}

export interface IUserExpertProfileVirtualEventDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertProfileVirtualEvent[];
}

export interface IUserExpertStatus {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  userStatusType?: IUserStatusType;
  userExpertProfiles?: IUserExpertProfile[] | null;
}

export interface IUserExpertStatusDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IUserExpertStatus[];
}

export enum IUserStatusType {
  Active = 'Active',
  OnboardNetwork = 'OnboardNetwork',
}

export interface IVirtualEvent {
  id?: string | null;
  isActive?: boolean;
  title?: string | null;
  description?: string | null;
  location?: string | null;
  picture?: string | null;
  /** @format date-time */
  eventDate?: string | Date;
  eventTimeSlot?: string | null;
  linkURL?: string | null;
  displayForAll?: boolean;
  virtualEventTags?: IVirtualEventTag[] | null;
  userExpertProfileVirtualEvents?: IUserExpertProfileVirtualEvent[] | null;
  userExpertProfileViews?: IUserExpertProfileView[] | null;
}

export interface IVirtualEventDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IVirtualEvent[];
}

export interface IVirtualEventTag {
  id?: string | null;
  isActive?: boolean;
  virtualEventID?: string | null;
  tagID?: string | null;
  virtualEvent?: IVirtualEvent;
  tag?: ITag;
}

export interface IVirtualEventTagDynamicResponse {
  /** @format int32 */
  count?: number | null;
  items: IVirtualEventTag[];
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title TheBio Crm API
 */
export const ApiPaths = {
  AccountsGeneratePasswordCreate: 'Accounts/GeneratePassword',
  AccountsLoginWithCodeCreate: 'Accounts/LoginWithCode',
  AccountsLogoutCreate: 'Accounts/Logout',
  AccountsRefreshTokenCreate: 'Accounts/RefreshToken',
  AccountsGetCurrentAppUserList: 'Accounts/GetCurrentAppUser',
  AccountsTestMeList: 'Accounts/TestMe',
  ArticleCategoriesDeleteDelete: (id: any) => `ArticleCategories/Delete/${id}`,
  ArticleCategoriesGetAllDynamicList: 'ArticleCategories/GetAllDynamic',
  ArticleCategories: 'ArticleCategories',
  ArticleCategoriesCreateCreate: 'ArticleCategories/Create',
  ArticleCategoriesPatchPartialUpdate: (id: any) => `ArticleCategories/Patch/${id}`,
  ArticleCommentRepliesDeleteDelete: (id: any) => `ArticleCommentReplies/Delete/${id}`,
  ArticleCommentRepliesGetAllDynamicList: 'ArticleCommentReplies/GetAllDynamic',
  ArticleCommentReplies: 'ArticleCommentReplies',
  ArticleCommentRepliesCreateCreate: 'ArticleCommentReplies/Create',
  ArticleCommentRepliesPatchPartialUpdate: (id: any) => `ArticleCommentReplies/Patch/${id}`,
  ArticleCommentsDeleteDelete: (id: any) => `ArticleComments/Delete/${id}`,
  ArticleCommentsGetAllDynamicList: 'ArticleComments/GetAllDynamic',
  ArticleComments: 'ArticleComments',
  ArticleCommentsCreateCreate: 'ArticleComments/Create',
  ArticleCommentsPatchPartialUpdate: (id: any) => `ArticleComments/Patch/${id}`,
  ArticlePicturesDeleteDelete: (id: any) => `ArticlePictures/Delete/${id}`,
  ArticlePicturesGetAllDynamicList: 'ArticlePictures/GetAllDynamic',
  ArticlePictures: 'ArticlePictures',
  ArticlePicturesCreateCreate: 'ArticlePictures/Create',
  ArticlePicturesPatchPartialUpdate: (id: any) => `ArticlePictures/Patch/${id}`,
  ArticleReactionsDeleteDelete: (id: any) => `ArticleReactions/Delete/${id}`,
  ArticleReactionsGetAllDynamicList: 'ArticleReactions/GetAllDynamic',
  ArticleReactions: 'ArticleReactions',
  ArticleReactionsCreateCreate: 'ArticleReactions/Create',
  ArticleReactionsPatchPartialUpdate: (id: any) => `ArticleReactions/Patch/${id}`,
  ArticlesDeleteDelete: (id: any) => `Articles/Delete/${id}`,
  ArticlesGetAllDynamicList: 'Articles/GetAllDynamic',
  Articles: 'Articles',
  ArticlesCreateCreate: 'Articles/Create',
  ArticlesPatchPartialUpdate: (id: any) => `Articles/Patch/${id}`,
  ArticleTagsDeleteDelete: (id: any) => `ArticleTags/Delete/${id}`,
  ArticleTagsGetAllDynamicList: 'ArticleTags/GetAllDynamic',
  ArticleTags: 'ArticleTags',
  ArticleTagsCreateCreate: 'ArticleTags/Create',
  ArticleTagsPatchPartialUpdate: (id: any) => `ArticleTags/Patch/${id}`,
  CampaignsDeleteDelete: (id: any) => `Campaigns/Delete/${id}`,
  CampaignsGetAllDynamicList: 'Campaigns/GetAllDynamic',
  Campaigns: 'Campaigns',
  CampaignsCreateCreate: 'Campaigns/Create',
  CampaignsPatchPartialUpdate: (id: any) => `Campaigns/Patch/${id}`,
  ChatConversationMessagesDeleteDelete: (id: any) => `ChatConversationMessages/Delete/${id}`,
  ChatConversationMessagesGetAllDynamicList: 'ChatConversationMessages/GetAllDynamic',
  ChatConversationMessages: 'ChatConversationMessages',
  ChatConversationMessagesCreateCreate: 'ChatConversationMessages/Create',
  ChatConversationMessagesPatchPartialUpdate: (id: any) => `ChatConversationMessages/Patch/${id}`,
  ChatConversationsDeleteDelete: (id: any) => `ChatConversations/Delete/${id}`,
  ChatConversationsGetAllDynamicList: 'ChatConversations/GetAllDynamic',
  ChatConversations: 'ChatConversations',
  ChatConversationsCreateCreate: 'ChatConversations/Create',
  ChatConversationsPatchPartialUpdate: (id: any) => `ChatConversations/Patch/${id}`,
  CitiesDeleteDelete: (id: any) => `Cities/Delete/${id}`,
  CitiesGetAllDynamicList: 'Cities/GetAllDynamic',
  Cities: 'Cities',
  CitiesCreateCreate: 'Cities/Create',
  CitiesPatchPartialUpdate: (id: any) => `Cities/Patch/${id}`,
  CommonPagesDeleteDelete: (id: any) => `CommonPages/Delete/${id}`,
  CommonPagesGetAllDynamicList: 'CommonPages/GetAllDynamic',
  CommonPages: 'CommonPages',
  CommonPagesCreateCreate: 'CommonPages/Create',
  CommonPagesPatchPartialUpdate: (id: any) => `CommonPages/Patch/${id}`,
  EmailContentsDeleteDelete: (id: any) => `EmailContents/Delete/${id}`,
  EmailContentsGetAllDynamicList: 'EmailContents/GetAllDynamic',
  EmailContents: 'EmailContents',
  EmailContentsCreateCreate: 'EmailContents/Create',
  EmailContentsPatchPartialUpdate: (id: any) => `EmailContents/Patch/${id}`,
  EmailContentsPreviewDetail: (id: any) => `EmailContents/Preview/${id}`,
  EmailContentsSendList: 'EmailContents/Send',
  ExpertTypesDeleteDelete: (id: any) => `ExpertTypes/Delete/${id}`,
  ExpertTypesGetAllDynamicList: 'ExpertTypes/GetAllDynamic',
  ExpertTypes: 'ExpertTypes',
  ExpertTypesCreateCreate: 'ExpertTypes/Create',
  ExpertTypesPatchPartialUpdate: (id: any) => `ExpertTypes/Patch/${id}`,
  FieldOfOccupationsDeleteDelete: (id: any) => `FieldOfOccupations/Delete/${id}`,
  FieldOfOccupationsGetAllDynamicList: 'FieldOfOccupations/GetAllDynamic',
  FieldOfOccupations: 'FieldOfOccupations',
  FieldOfOccupationsCreateCreate: 'FieldOfOccupations/Create',
  FieldOfOccupationsPatchPartialUpdate: (id: any) => `FieldOfOccupations/Patch/${id}`,
  GlobalParametersDeleteDelete: (id: any) => `GlobalParameters/Delete/${id}`,
  GlobalParametersGetAllDynamicList: 'GlobalParameters/GetAllDynamic',
  GlobalParameters: 'GlobalParameters',
  GlobalParametersCreateCreate: 'GlobalParameters/Create',
  GlobalParametersPatchPartialUpdate: (id: any) => `GlobalParameters/Patch/${id}`,
  IndustriesDeleteDelete: (id: any) => `Industries/Delete/${id}`,
  IndustriesGetAllDynamicList: 'Industries/GetAllDynamic',
  Industries: 'Industries',
  IndustriesCreateCreate: 'Industries/Create',
  IndustriesPatchPartialUpdate: (id: any) => `Industries/Patch/${id}`,
  LabelsDeleteDelete: (id: any) => `Labels/Delete/${id}`,
  LabelsGetAllDynamicList: 'Labels/GetAllDynamic',
  Labels: 'Labels',
  LabelsCreateCreate: 'Labels/Create',
  LabelsPatchPartialUpdate: (id: any) => `Labels/Patch/${id}`,
  LabelSourcesDeleteDelete: (id: any) => `LabelSources/Delete/${id}`,
  LabelSourcesGetAllDynamicList: 'LabelSources/GetAllDynamic',
  LabelSources: 'LabelSources',
  LabelSourcesCreateCreate: 'LabelSources/Create',
  LabelSourcesPatchPartialUpdate: (id: any) => `LabelSources/Patch/${id}`,
  LanguagesDeleteDelete: (id: any) => `Languages/Delete/${id}`,
  LanguagesGetAllDynamicList: 'Languages/GetAllDynamic',
  Languages: 'Languages',
  LanguagesCreateCreate: 'Languages/Create',
  LanguagesPatchPartialUpdate: (id: any) => `Languages/Patch/${id}`,
  MediaPrivateServicesUploadFileToCloudCreate: 'MediaPrivateServices/UploadFileToCloud',
  MediaPrivateServicesRemoveFileFromCloudUpdate: 'MediaPrivateServices/RemoveFileFromCloud',
  MediaPrivateServicesDownloadFileFromCloudList: 'MediaPrivateServices/DownloadFileFromCloud',
  MediaUploadsUploadFileToCloudCreate: 'MediaUploads/UploadFileToCloud',
  MediaUploadsRemoveFileFromCloudUpdate: 'MediaUploads/RemoveFileFromCloud',
  SmsContentsDeleteDelete: (id: any) => `SMSContents/Delete/${id}`,
  SmsContentsGetAllDynamicList: 'SMSContents/GetAllDynamic',
  SMSContents: 'SMSContents',
  SmsContentsCreateCreate: 'SMSContents/Create',
  SmsContentsPatchPartialUpdate: (id: any) => `SMSContents/Patch/${id}`,
  SmsContentsSendList: 'SMSContents/Send',
  SpeakLanguagesDeleteDelete: (id: any) => `SpeakLanguages/Delete/${id}`,
  SpeakLanguagesGetAllDynamicList: 'SpeakLanguages/GetAllDynamic',
  SpeakLanguages: 'SpeakLanguages',
  SpeakLanguagesCreateCreate: 'SpeakLanguages/Create',
  SpeakLanguagesPatchPartialUpdate: (id: any) => `SpeakLanguages/Patch/${id}`,
  SponsorCompaniesDeleteDelete: (id: any) => `SponsorCompanies/Delete/${id}`,
  SponsorCompaniesGetAllDynamicList: 'SponsorCompanies/GetAllDynamic',
  SponsorCompanies: 'SponsorCompanies',
  SponsorCompaniesCreateCreate: 'SponsorCompanies/Create',
  SponsorCompaniesPatchPartialUpdate: (id: any) => `SponsorCompanies/Patch/${id}`,
  SurveyOptionsDeleteDelete: (id: any) => `SurveyOptions/Delete/${id}`,
  SurveyOptionsGetAllDynamicList: 'SurveyOptions/GetAllDynamic',
  SurveyOptions: 'SurveyOptions',
  SurveyOptionsCreateCreate: 'SurveyOptions/Create',
  SurveyOptionsPatchPartialUpdate: (id: any) => `SurveyOptions/Patch/${id}`,
  SurveysDeleteDelete: (id: any) => `Surveys/Delete/${id}`,
  SurveysGetAllDynamicList: 'Surveys/GetAllDynamic',
  Surveys: 'Surveys',
  SurveysCreateCreate: 'Surveys/Create',
  SurveysPatchPartialUpdate: (id: any) => `Surveys/Patch/${id}`,
  SurveyTagsDeleteDelete: (id: any) => `SurveyTags/Delete/${id}`,
  SurveyTagsGetAllDynamicList: 'SurveyTags/GetAllDynamic',
  SurveyTags: 'SurveyTags',
  SurveyTagsCreateCreate: 'SurveyTags/Create',
  SurveyTagsPatchPartialUpdate: (id: any) => `SurveyTags/Patch/${id}`,
  TagsDeleteDelete: (id: any) => `Tags/Delete/${id}`,
  TagsGetAllDynamicList: 'Tags/GetAllDynamic',
  Tags: 'Tags',
  TagsCreateCreate: 'Tags/Create',
  TagsPatchPartialUpdate: (id: any) => `Tags/Patch/${id}`,
  UserCrmProfilePermissionsDeleteDelete: (id: any) => `UserCrmProfilePermissions/Delete/${id}`,
  UserCrmProfilePermissionsGetAllDynamicList: 'UserCrmProfilePermissions/GetAllDynamic',
  UserCrmProfilePermissions: 'UserCrmProfilePermissions',
  UserCrmProfilePermissionsCreateCreate: 'UserCrmProfilePermissions/Create',
  UserCrmProfilePermissionsPatchPartialUpdate: (id: any) => `UserCrmProfilePermissions/Patch/${id}`,
  UserCrmProfilesDeleteDelete: (id: any) => `UserCrmProfiles/Delete/${id}`,
  UserCrmProfilesGetAllDynamicList: 'UserCrmProfiles/GetAllDynamic',
  UserCrmProfiles: 'UserCrmProfiles',
  UserCrmProfilesCreateCreate: 'UserCrmProfiles/Create',
  UserCrmProfilesPatchPartialUpdate: (id: any) => `UserCrmProfiles/Patch/${id}`,
  UserExpertProfileArticlesDeleteDelete: (id: any) => `UserExpertProfileArticles/Delete/${id}`,
  UserExpertProfileArticlesGetAllDynamicList: 'UserExpertProfileArticles/GetAllDynamic',
  UserExpertProfileArticles: 'UserExpertProfileArticles',
  UserExpertProfileArticlesCreateCreate: 'UserExpertProfileArticles/Create',
  UserExpertProfileArticlesPatchPartialUpdate: (id: any) => `UserExpertProfileArticles/Patch/${id}`,
  UserExpertProfileFollowsDeleteDelete: (id: any) => `UserExpertProfileFollows/Delete/${id}`,
  UserExpertProfileFollowsGetAllDynamicList: 'UserExpertProfileFollows/GetAllDynamic',
  UserExpertProfileFollows: 'UserExpertProfileFollows',
  UserExpertProfileFollowsCreateCreate: 'UserExpertProfileFollows/Create',
  UserExpertProfileFollowsPatchPartialUpdate: (id: any) => `UserExpertProfileFollows/Patch/${id}`,
  UserExpertProfilesDeleteDelete: (id: any) => `UserExpertProfiles/Delete/${id}`,
  UserExpertProfilesGetAllDynamicList: 'UserExpertProfiles/GetAllDynamic',
  UserExpertProfiles: 'UserExpertProfiles',
  UserExpertProfilesCreateCreate: 'UserExpertProfiles/Create',
  UserExpertProfilesPatchPartialUpdate: (id: any) => `UserExpertProfiles/Patch/${id}`,
  UserExpertProfileSpeakLanguagesDeleteDelete: (id: any) =>
    `UserExpertProfileSpeakLanguages/Delete/${id}`,
  UserExpertProfileSpeakLanguagesGetAllDynamicList: 'UserExpertProfileSpeakLanguages/GetAllDynamic',
  UserExpertProfileSpeakLanguages: 'UserExpertProfileSpeakLanguages',
  UserExpertProfileSpeakLanguagesCreateCreate: 'UserExpertProfileSpeakLanguages/Create',
  UserExpertProfileSpeakLanguagesPatchPartialUpdate: (id: any) =>
    `UserExpertProfileSpeakLanguages/Patch/${id}`,
  UserExpertProfileSurveysDeleteDelete: (id: any) => `UserExpertProfileSurveys/Delete/${id}`,
  UserExpertProfileSurveysGetAllDynamicList: 'UserExpertProfileSurveys/GetAllDynamic',
  UserExpertProfileSurveys: 'UserExpertProfileSurveys',
  UserExpertProfileSurveysCreateCreate: 'UserExpertProfileSurveys/Create',
  UserExpertProfileSurveysPatchPartialUpdate: (id: any) => `UserExpertProfileSurveys/Patch/${id}`,
  UserExpertProfileTagsDeleteDelete: (id: any) => `UserExpertProfileTags/Delete/${id}`,
  UserExpertProfileTagsGetAllDynamicList: 'UserExpertProfileTags/GetAllDynamic',
  UserExpertProfileTags: 'UserExpertProfileTags',
  UserExpertProfileTagsCreateCreate: 'UserExpertProfileTags/Create',
  UserExpertProfileTagsPatchPartialUpdate: (id: any) => `UserExpertProfileTags/Patch/${id}`,
  UserExpertProfileViewsDeleteDelete: (id: any) => `UserExpertProfileViews/Delete/${id}`,
  UserExpertProfileViewsGetAllDynamicList: 'UserExpertProfileViews/GetAllDynamic',
  UserExpertProfileViews: 'UserExpertProfileViews',
  UserExpertProfileViewsCreateCreate: 'UserExpertProfileViews/Create',
  UserExpertProfileViewsPatchPartialUpdate: (id: any) => `UserExpertProfileViews/Patch/${id}`,
  UserExpertProfileVirtualEventsDeleteDelete: (id: any) =>
    `UserExpertProfileVirtualEvents/Delete/${id}`,
  UserExpertProfileVirtualEventsGetAllDynamicList: 'UserExpertProfileVirtualEvents/GetAllDynamic',
  UserExpertProfileVirtualEvents: 'UserExpertProfileVirtualEvents',
  UserExpertProfileVirtualEventsCreateCreate: 'UserExpertProfileVirtualEvents/Create',
  UserExpertProfileVirtualEventsPatchPartialUpdate: (id: any) =>
    `UserExpertProfileVirtualEvents/Patch/${id}`,
  UserExpertStatusesDeleteDelete: (id: any) => `UserExpertStatuses/Delete/${id}`,
  UserExpertStatusesGetAllDynamicList: 'UserExpertStatuses/GetAllDynamic',
  UserExpertStatuses: 'UserExpertStatuses',
  UserExpertStatusesCreateCreate: 'UserExpertStatuses/Create',
  UserExpertStatusesPatchPartialUpdate: (id: any) => `UserExpertStatuses/Patch/${id}`,
  VirtualEventsDeleteDelete: (id: any) => `VirtualEvents/Delete/${id}`,
  VirtualEventsGetAllDynamicList: 'VirtualEvents/GetAllDynamic',
  VirtualEvents: 'VirtualEvents',
  VirtualEventsCreateCreate: 'VirtualEvents/Create',
  VirtualEventsPatchPartialUpdate: (id: any) => `VirtualEvents/Patch/${id}`,
  VirtualEventTagsDeleteDelete: (id: any) => `VirtualEventTags/Delete/${id}`,
  VirtualEventTagsGetAllDynamicList: 'VirtualEventTags/GetAllDynamic',
  VirtualEventTags: 'VirtualEventTags',
  VirtualEventTagsCreateCreate: 'VirtualEventTags/Create',
  VirtualEventTagsPatchPartialUpdate: (id: any) => `VirtualEventTags/Patch/${id}`,
};

export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsGeneratePasswordCreate
     * @request POST:/api/Accounts/GeneratePassword
     * @secure
     */
    accountsGeneratePasswordCreate: (data: IGeneratePasswordRequest, params: RequestParams = {}) =>
      this.request<string, any>({
        path: ApiPaths.AccountsGeneratePasswordCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsLoginWithCodeCreate
     * @request POST:/api/Accounts/LoginWithCode
     * @secure
     */
    accountsLoginWithCodeCreate: (data: ILoginRequest, params: RequestParams = {}) =>
      this.request<ILoginResponse, any>({
        path: ApiPaths.AccountsLoginWithCodeCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsLogoutCreate
     * @request POST:/api/Accounts/Logout
     * @secure
     */
    accountsLogoutCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: ApiPaths.AccountsLogoutCreate,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsRefreshTokenCreate
     * @request POST:/api/Accounts/RefreshToken
     * @secure
     */
    accountsRefreshTokenCreate: (data: IJwt, params: RequestParams = {}) =>
      this.request<IJwt, any>({
        path: ApiPaths.AccountsRefreshTokenCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsGetCurrentAppUserList
     * @request GET:/api/Accounts/GetCurrentAppUser
     * @secure
     */
    accountsGetCurrentAppUserList: (params: RequestParams = {}) =>
      this.request<ICurrentUserProfileResponse, any>({
        path: ApiPaths.AccountsGetCurrentAppUserList,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Accounts
     * @name AccountsTestMeList
     * @request GET:/api/Accounts/TestMe
     * @secure
     */
    accountsTestMeList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: ApiPaths.AccountsTestMeList,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCategories
     * @name ArticleCategoriesDeleteDelete
     * @request DELETE:/api/ArticleCategories/Delete/{id}
     * @secure
     */
    articleCategoriesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IArticleCategory, any>({
        path: ApiPaths.ArticleCategoriesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCategories
     * @name ArticleCategoriesGetAllDynamicList
     * @request GET:/api/ArticleCategories/GetAllDynamic
     * @secure
     */
    articleCategoriesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IArticleCategoryDynamicResponse, any>({
        path: ApiPaths.ArticleCategoriesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCategories
     * @name ArticleCategoriesCreateCreate
     * @request POST:/api/ArticleCategories/Create
     * @secure
     */
    articleCategoriesCreateCreate: (data: IArticleCategory, params: RequestParams = {}) =>
      this.request<IArticleCategory, any>({
        path: ApiPaths.ArticleCategoriesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCategories
     * @name ArticleCategoriesPatchPartialUpdate
     * @request PATCH:/api/ArticleCategories/Patch/{id}
     * @secure
     */
    articleCategoriesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IArticleCategory, any>({
        path: ApiPaths.ArticleCategoriesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCommentReplies
     * @name ArticleCommentRepliesDeleteDelete
     * @request DELETE:/api/ArticleCommentReplies/Delete/{id}
     * @secure
     */
    articleCommentRepliesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IArticleCommentReply, any>({
        path: ApiPaths.ArticleCommentRepliesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCommentReplies
     * @name ArticleCommentRepliesGetAllDynamicList
     * @request GET:/api/ArticleCommentReplies/GetAllDynamic
     * @secure
     */
    articleCommentRepliesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IArticleCommentReplyDynamicResponse, any>({
        path: ApiPaths.ArticleCommentRepliesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCommentReplies
     * @name ArticleCommentRepliesCreateCreate
     * @request POST:/api/ArticleCommentReplies/Create
     * @secure
     */
    articleCommentRepliesCreateCreate: (data: IArticleCommentReply, params: RequestParams = {}) =>
      this.request<IArticleCommentReply, any>({
        path: ApiPaths.ArticleCommentRepliesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleCommentReplies
     * @name ArticleCommentRepliesPatchPartialUpdate
     * @request PATCH:/api/ArticleCommentReplies/Patch/{id}
     * @secure
     */
    articleCommentRepliesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IArticleCommentReply, any>({
        path: ApiPaths.ArticleCommentRepliesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleComments
     * @name ArticleCommentsDeleteDelete
     * @request DELETE:/api/ArticleComments/Delete/{id}
     * @secure
     */
    articleCommentsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IArticleComment, any>({
        path: ApiPaths.ArticleCommentsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleComments
     * @name ArticleCommentsGetAllDynamicList
     * @request GET:/api/ArticleComments/GetAllDynamic
     * @secure
     */
    articleCommentsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IArticleCommentDynamicResponse, any>({
        path: ApiPaths.ArticleCommentsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleComments
     * @name ArticleCommentsCreateCreate
     * @request POST:/api/ArticleComments/Create
     * @secure
     */
    articleCommentsCreateCreate: (data: IArticleComment, params: RequestParams = {}) =>
      this.request<IArticleComment, any>({
        path: ApiPaths.ArticleCommentsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleComments
     * @name ArticleCommentsPatchPartialUpdate
     * @request PATCH:/api/ArticleComments/Patch/{id}
     * @secure
     */
    articleCommentsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IArticleComment, any>({
        path: ApiPaths.ArticleCommentsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticlePictures
     * @name ArticlePicturesDeleteDelete
     * @request DELETE:/api/ArticlePictures/Delete/{id}
     * @secure
     */
    articlePicturesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IArticlePicture, any>({
        path: ApiPaths.ArticlePicturesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticlePictures
     * @name ArticlePicturesGetAllDynamicList
     * @request GET:/api/ArticlePictures/GetAllDynamic
     * @secure
     */
    articlePicturesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IArticlePictureDynamicResponse, any>({
        path: ApiPaths.ArticlePicturesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticlePictures
     * @name ArticlePicturesCreateCreate
     * @request POST:/api/ArticlePictures/Create
     * @secure
     */
    articlePicturesCreateCreate: (data: IArticlePicture, params: RequestParams = {}) =>
      this.request<IArticlePicture, any>({
        path: ApiPaths.ArticlePicturesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticlePictures
     * @name ArticlePicturesPatchPartialUpdate
     * @request PATCH:/api/ArticlePictures/Patch/{id}
     * @secure
     */
    articlePicturesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IArticlePicture, any>({
        path: ApiPaths.ArticlePicturesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReactions
     * @name ArticleReactionsDeleteDelete
     * @request DELETE:/api/ArticleReactions/Delete/{id}
     * @secure
     */
    articleReactionsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IArticleReaction, any>({
        path: ApiPaths.ArticleReactionsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReactions
     * @name ArticleReactionsGetAllDynamicList
     * @request GET:/api/ArticleReactions/GetAllDynamic
     * @secure
     */
    articleReactionsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IArticleReactionDynamicResponse, any>({
        path: ApiPaths.ArticleReactionsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReactions
     * @name ArticleReactionsCreateCreate
     * @request POST:/api/ArticleReactions/Create
     * @secure
     */
    articleReactionsCreateCreate: (data: IArticleReaction, params: RequestParams = {}) =>
      this.request<IArticleReaction, any>({
        path: ApiPaths.ArticleReactionsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleReactions
     * @name ArticleReactionsPatchPartialUpdate
     * @request PATCH:/api/ArticleReactions/Patch/{id}
     * @secure
     */
    articleReactionsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IArticleReaction, any>({
        path: ApiPaths.ArticleReactionsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name ArticlesDeleteDelete
     * @request DELETE:/api/Articles/Delete/{id}
     * @secure
     */
    articlesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IArticle, any>({
        path: ApiPaths.ArticlesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name ArticlesGetAllDynamicList
     * @request GET:/api/Articles/GetAllDynamic
     * @secure
     */
    articlesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IArticleDynamicResponse, any>({
        path: ApiPaths.ArticlesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name ArticlesCreateCreate
     * @request POST:/api/Articles/Create
     * @secure
     */
    articlesCreateCreate: (data: IArticle, params: RequestParams = {}) =>
      this.request<IArticle, any>({
        path: ApiPaths.ArticlesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Articles
     * @name ArticlesPatchPartialUpdate
     * @request PATCH:/api/Articles/Patch/{id}
     * @secure
     */
    articlesPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<IArticle, any>({
        path: ApiPaths.ArticlesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleTags
     * @name ArticleTagsDeleteDelete
     * @request DELETE:/api/ArticleTags/Delete/{id}
     * @secure
     */
    articleTagsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IArticleTag, any>({
        path: ApiPaths.ArticleTagsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleTags
     * @name ArticleTagsGetAllDynamicList
     * @request GET:/api/ArticleTags/GetAllDynamic
     * @secure
     */
    articleTagsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IArticleTagDynamicResponse, any>({
        path: ApiPaths.ArticleTagsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleTags
     * @name ArticleTagsCreateCreate
     * @request POST:/api/ArticleTags/Create
     * @secure
     */
    articleTagsCreateCreate: (data: IArticleTag, params: RequestParams = {}) =>
      this.request<IArticleTag, any>({
        path: ApiPaths.ArticleTagsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ArticleTags
     * @name ArticleTagsPatchPartialUpdate
     * @request PATCH:/api/ArticleTags/Patch/{id}
     * @secure
     */
    articleTagsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<IArticleTag, any>({
        path: ApiPaths.ArticleTagsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaigns
     * @name CampaignsDeleteDelete
     * @request DELETE:/api/Campaigns/Delete/{id}
     * @secure
     */
    campaignsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ICampaign, any>({
        path: ApiPaths.CampaignsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaigns
     * @name CampaignsGetAllDynamicList
     * @request GET:/api/Campaigns/GetAllDynamic
     * @secure
     */
    campaignsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ICampaignDynamicResponse, any>({
        path: ApiPaths.CampaignsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaigns
     * @name CampaignsCreateCreate
     * @request POST:/api/Campaigns/Create
     * @secure
     */
    campaignsCreateCreate: (data: ICampaign, params: RequestParams = {}) =>
      this.request<ICampaign, any>({
        path: ApiPaths.CampaignsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Campaigns
     * @name CampaignsPatchPartialUpdate
     * @request PATCH:/api/Campaigns/Patch/{id}
     * @secure
     */
    campaignsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ICampaign, any>({
        path: ApiPaths.CampaignsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversationMessages
     * @name ChatConversationMessagesDeleteDelete
     * @request DELETE:/api/ChatConversationMessages/Delete/{id}
     * @secure
     */
    chatConversationMessagesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IChatConversationMessage, any>({
        path: ApiPaths.ChatConversationMessagesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversationMessages
     * @name ChatConversationMessagesGetAllDynamicList
     * @request GET:/api/ChatConversationMessages/GetAllDynamic
     * @secure
     */
    chatConversationMessagesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IChatConversationMessageDynamicResponse, any>({
        path: ApiPaths.ChatConversationMessagesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversationMessages
     * @name ChatConversationMessagesCreateCreate
     * @request POST:/api/ChatConversationMessages/Create
     * @secure
     */
    chatConversationMessagesCreateCreate: (
      data: IChatConversationMessage,
      params: RequestParams = {},
    ) =>
      this.request<IChatConversationMessage, any>({
        path: ApiPaths.ChatConversationMessagesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversationMessages
     * @name ChatConversationMessagesPatchPartialUpdate
     * @request PATCH:/api/ChatConversationMessages/Patch/{id}
     * @secure
     */
    chatConversationMessagesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IChatConversationMessage, any>({
        path: ApiPaths.ChatConversationMessagesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversations
     * @name ChatConversationsDeleteDelete
     * @request DELETE:/api/ChatConversations/Delete/{id}
     * @secure
     */
    chatConversationsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IChatConversation, any>({
        path: ApiPaths.ChatConversationsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversations
     * @name ChatConversationsGetAllDynamicList
     * @request GET:/api/ChatConversations/GetAllDynamic
     * @secure
     */
    chatConversationsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IChatConversationDynamicResponse, any>({
        path: ApiPaths.ChatConversationsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversations
     * @name ChatConversationsCreateCreate
     * @request POST:/api/ChatConversations/Create
     * @secure
     */
    chatConversationsCreateCreate: (data: IChatConversation, params: RequestParams = {}) =>
      this.request<IChatConversation, any>({
        path: ApiPaths.ChatConversationsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ChatConversations
     * @name ChatConversationsPatchPartialUpdate
     * @request PATCH:/api/ChatConversations/Patch/{id}
     * @secure
     */
    chatConversationsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IChatConversation, any>({
        path: ApiPaths.ChatConversationsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cities
     * @name CitiesDeleteDelete
     * @request DELETE:/api/Cities/Delete/{id}
     * @secure
     */
    citiesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ICity, any>({
        path: ApiPaths.CitiesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cities
     * @name CitiesGetAllDynamicList
     * @request GET:/api/Cities/GetAllDynamic
     * @secure
     */
    citiesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ICityDynamicResponse, any>({
        path: ApiPaths.CitiesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cities
     * @name CitiesCreateCreate
     * @request POST:/api/Cities/Create
     * @secure
     */
    citiesCreateCreate: (data: ICity, params: RequestParams = {}) =>
      this.request<ICity, any>({
        path: ApiPaths.CitiesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cities
     * @name CitiesPatchPartialUpdate
     * @request PATCH:/api/Cities/Patch/{id}
     * @secure
     */
    citiesPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ICity, any>({
        path: ApiPaths.CitiesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommonPages
     * @name CommonPagesDeleteDelete
     * @request DELETE:/api/CommonPages/Delete/{id}
     * @secure
     */
    commonPagesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ICommonPage, any>({
        path: ApiPaths.CommonPagesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommonPages
     * @name CommonPagesGetAllDynamicList
     * @request GET:/api/CommonPages/GetAllDynamic
     * @secure
     */
    commonPagesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ICommonPageDynamicResponse, any>({
        path: ApiPaths.CommonPagesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommonPages
     * @name CommonPagesCreateCreate
     * @request POST:/api/CommonPages/Create
     * @secure
     */
    commonPagesCreateCreate: (data: ICommonPage, params: RequestParams = {}) =>
      this.request<ICommonPage, any>({
        path: ApiPaths.CommonPagesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags CommonPages
     * @name CommonPagesPatchPartialUpdate
     * @request PATCH:/api/CommonPages/Patch/{id}
     * @secure
     */
    commonPagesPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ICommonPage, any>({
        path: ApiPaths.CommonPagesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailContents
     * @name EmailContentsDeleteDelete
     * @request DELETE:/api/EmailContents/Delete/{id}
     * @secure
     */
    emailContentsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IEmailContent, any>({
        path: ApiPaths.EmailContentsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailContents
     * @name EmailContentsGetAllDynamicList
     * @request GET:/api/EmailContents/GetAllDynamic
     * @secure
     */
    emailContentsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IEmailContentDynamicResponse, any>({
        path: ApiPaths.EmailContentsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailContents
     * @name EmailContentsCreateCreate
     * @request POST:/api/EmailContents/Create
     * @secure
     */
    emailContentsCreateCreate: (data: IEmailContent, params: RequestParams = {}) =>
      this.request<IEmailContent, any>({
        path: ApiPaths.EmailContentsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailContents
     * @name EmailContentsPatchPartialUpdate
     * @request PATCH:/api/EmailContents/Patch/{id}
     * @secure
     */
    emailContentsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<IEmailContent, any>({
        path: ApiPaths.EmailContentsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailContents
     * @name EmailContentsPreviewDetail
     * @request GET:/api/EmailContents/Preview/{id}
     * @secure
     */
    emailContentsPreviewDetail: (id: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: ApiPaths.EmailContentsPreviewDetail(id),
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags EmailContents
     * @name EmailContentsSendList
     * @request GET:/api/EmailContents/Send
     * @secure
     */
    emailContentsSendList: (
      query?: {
        id?: string;
        email?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: ApiPaths.EmailContentsSendList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExpertTypes
     * @name ExpertTypesDeleteDelete
     * @request DELETE:/api/ExpertTypes/Delete/{id}
     * @secure
     */
    expertTypesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IExpertType, any>({
        path: ApiPaths.ExpertTypesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExpertTypes
     * @name ExpertTypesGetAllDynamicList
     * @request GET:/api/ExpertTypes/GetAllDynamic
     * @secure
     */
    expertTypesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IExpertTypeDynamicResponse, any>({
        path: ApiPaths.ExpertTypesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExpertTypes
     * @name ExpertTypesCreateCreate
     * @request POST:/api/ExpertTypes/Create
     * @secure
     */
    expertTypesCreateCreate: (data: IExpertType, params: RequestParams = {}) =>
      this.request<IExpertType, any>({
        path: ApiPaths.ExpertTypesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExpertTypes
     * @name ExpertTypesPatchPartialUpdate
     * @request PATCH:/api/ExpertTypes/Patch/{id}
     * @secure
     */
    expertTypesPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<IExpertType, any>({
        path: ApiPaths.ExpertTypesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FieldOfOccupations
     * @name FieldOfOccupationsDeleteDelete
     * @request DELETE:/api/FieldOfOccupations/Delete/{id}
     * @secure
     */
    fieldOfOccupationsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IFieldOfOccupation, any>({
        path: ApiPaths.FieldOfOccupationsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FieldOfOccupations
     * @name FieldOfOccupationsGetAllDynamicList
     * @request GET:/api/FieldOfOccupations/GetAllDynamic
     * @secure
     */
    fieldOfOccupationsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IFieldOfOccupationDynamicResponse, any>({
        path: ApiPaths.FieldOfOccupationsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FieldOfOccupations
     * @name FieldOfOccupationsCreateCreate
     * @request POST:/api/FieldOfOccupations/Create
     * @secure
     */
    fieldOfOccupationsCreateCreate: (data: IFieldOfOccupation, params: RequestParams = {}) =>
      this.request<IFieldOfOccupation, any>({
        path: ApiPaths.FieldOfOccupationsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FieldOfOccupations
     * @name FieldOfOccupationsPatchPartialUpdate
     * @request PATCH:/api/FieldOfOccupations/Patch/{id}
     * @secure
     */
    fieldOfOccupationsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IFieldOfOccupation, any>({
        path: ApiPaths.FieldOfOccupationsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalParameters
     * @name GlobalParametersDeleteDelete
     * @request DELETE:/api/GlobalParameters/Delete/{id}
     * @secure
     */
    globalParametersDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<string, any>({
        path: ApiPaths.GlobalParametersDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalParameters
     * @name GlobalParametersGetAllDynamicList
     * @request GET:/api/GlobalParameters/GetAllDynamic
     * @secure
     */
    globalParametersGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IGlobalParameterDynamicResponse, any>({
        path: ApiPaths.GlobalParametersGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalParameters
     * @name GlobalParametersCreateCreate
     * @request POST:/api/GlobalParameters/Create
     * @secure
     */
    globalParametersCreateCreate: (data: IGlobalParameter, params: RequestParams = {}) =>
      this.request<string, any>({
        path: ApiPaths.GlobalParametersCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags GlobalParameters
     * @name GlobalParametersPatchPartialUpdate
     * @request PATCH:/api/GlobalParameters/Patch/{id}
     * @secure
     */
    globalParametersPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IGlobalParameter, any>({
        path: ApiPaths.GlobalParametersPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Industries
     * @name IndustriesDeleteDelete
     * @request DELETE:/api/Industries/Delete/{id}
     * @secure
     */
    industriesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IIndustry, any>({
        path: ApiPaths.IndustriesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Industries
     * @name IndustriesGetAllDynamicList
     * @request GET:/api/Industries/GetAllDynamic
     * @secure
     */
    industriesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IIndustryDynamicResponse, any>({
        path: ApiPaths.IndustriesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Industries
     * @name IndustriesCreateCreate
     * @request POST:/api/Industries/Create
     * @secure
     */
    industriesCreateCreate: (data: IIndustry, params: RequestParams = {}) =>
      this.request<IIndustry, any>({
        path: ApiPaths.IndustriesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Industries
     * @name IndustriesPatchPartialUpdate
     * @request PATCH:/api/Industries/Patch/{id}
     * @secure
     */
    industriesPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<IIndustry, any>({
        path: ApiPaths.IndustriesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Labels
     * @name LabelsDeleteDelete
     * @request DELETE:/api/Labels/Delete/{id}
     * @secure
     */
    labelsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ILabel, any>({
        path: ApiPaths.LabelsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Labels
     * @name LabelsGetAllDynamicList
     * @request GET:/api/Labels/GetAllDynamic
     * @secure
     */
    labelsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ILabelDynamicResponse, any>({
        path: ApiPaths.LabelsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Labels
     * @name LabelsCreateCreate
     * @request POST:/api/Labels/Create
     * @secure
     */
    labelsCreateCreate: (data: ILabel, params: RequestParams = {}) =>
      this.request<ILabel, any>({
        path: ApiPaths.LabelsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Labels
     * @name LabelsPatchPartialUpdate
     * @request PATCH:/api/Labels/Patch/{id}
     * @secure
     */
    labelsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ILabel, any>({
        path: ApiPaths.LabelsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LabelSources
     * @name LabelSourcesDeleteDelete
     * @request DELETE:/api/LabelSources/Delete/{id}
     * @secure
     */
    labelSourcesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ILabelSource, any>({
        path: ApiPaths.LabelSourcesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LabelSources
     * @name LabelSourcesGetAllDynamicList
     * @request GET:/api/LabelSources/GetAllDynamic
     * @secure
     */
    labelSourcesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ILabelSourceDynamicResponse, any>({
        path: ApiPaths.LabelSourcesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LabelSources
     * @name LabelSourcesCreateCreate
     * @request POST:/api/LabelSources/Create
     * @secure
     */
    labelSourcesCreateCreate: (data: ILabelSource, params: RequestParams = {}) =>
      this.request<ILabelSource, any>({
        path: ApiPaths.LabelSourcesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags LabelSources
     * @name LabelSourcesPatchPartialUpdate
     * @request PATCH:/api/LabelSources/Patch/{id}
     * @secure
     */
    labelSourcesPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ILabelSource, any>({
        path: ApiPaths.LabelSourcesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Languages
     * @name LanguagesDeleteDelete
     * @request DELETE:/api/Languages/Delete/{id}
     * @secure
     */
    languagesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ILanguage, any>({
        path: ApiPaths.LanguagesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Languages
     * @name LanguagesGetAllDynamicList
     * @request GET:/api/Languages/GetAllDynamic
     * @secure
     */
    languagesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ILanguageDynamicResponse, any>({
        path: ApiPaths.LanguagesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Languages
     * @name LanguagesCreateCreate
     * @request POST:/api/Languages/Create
     * @secure
     */
    languagesCreateCreate: (data: ILanguage, params: RequestParams = {}) =>
      this.request<ILanguage, any>({
        path: ApiPaths.LanguagesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Languages
     * @name LanguagesPatchPartialUpdate
     * @request PATCH:/api/Languages/Patch/{id}
     * @secure
     */
    languagesPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ILanguage, any>({
        path: ApiPaths.LanguagesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaPrivateServices
     * @name MediaPrivateServicesUploadFileToCloudCreate
     * @request POST:/api/MediaPrivateServices/UploadFileToCloud
     * @secure
     */
    mediaPrivateServicesUploadFileToCloudCreate: (
      data: ICloudFileViewModel,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: ApiPaths.MediaPrivateServicesUploadFileToCloudCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaPrivateServices
     * @name MediaPrivateServicesRemoveFileFromCloudUpdate
     * @request PUT:/api/MediaPrivateServices/RemoveFileFromCloud
     * @secure
     */
    mediaPrivateServicesRemoveFileFromCloudUpdate: (
      query?: {
        filePath?: string;
        isImage?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: ApiPaths.MediaPrivateServicesRemoveFileFromCloudUpdate,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaPrivateServices
     * @name MediaPrivateServicesDownloadFileFromCloudList
     * @request GET:/api/MediaPrivateServices/DownloadFileFromCloud
     * @secure
     */
    mediaPrivateServicesDownloadFileFromCloudList: (
      query?: {
        fileName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: ApiPaths.MediaPrivateServicesDownloadFileFromCloudList,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaUploads
     * @name MediaUploadsUploadFileToCloudCreate
     * @request POST:/api/MediaUploads/UploadFileToCloud
     * @secure
     */
    mediaUploadsUploadFileToCloudCreate: (data: ICloudFileViewModel, params: RequestParams = {}) =>
      this.request<void, any>({
        path: ApiPaths.MediaUploadsUploadFileToCloudCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MediaUploads
     * @name MediaUploadsRemoveFileFromCloudUpdate
     * @request PUT:/api/MediaUploads/RemoveFileFromCloud
     * @secure
     */
    mediaUploadsRemoveFileFromCloudUpdate: (
      query?: {
        filePath?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: ApiPaths.MediaUploadsRemoveFileFromCloudUpdate,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SMSContents
     * @name SmsContentsDeleteDelete
     * @request DELETE:/api/SMSContents/Delete/{id}
     * @secure
     */
    smsContentsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ISMSContent, any>({
        path: ApiPaths.SmsContentsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SMSContents
     * @name SmsContentsGetAllDynamicList
     * @request GET:/api/SMSContents/GetAllDynamic
     * @secure
     */
    smsContentsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ISMSContentDynamicResponse, any>({
        path: ApiPaths.SmsContentsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SMSContents
     * @name SmsContentsCreateCreate
     * @request POST:/api/SMSContents/Create
     * @secure
     */
    smsContentsCreateCreate: (data: ISMSContent, params: RequestParams = {}) =>
      this.request<ISMSContent, any>({
        path: ApiPaths.SmsContentsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SMSContents
     * @name SmsContentsPatchPartialUpdate
     * @request PATCH:/api/SMSContents/Patch/{id}
     * @secure
     */
    smsContentsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ISMSContent, any>({
        path: ApiPaths.SmsContentsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SMSContents
     * @name SmsContentsSendList
     * @request GET:/api/SMSContents/Send
     * @secure
     */
    smsContentsSendList: (
      query?: {
        id?: string;
        phoneNumber?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<string, any>({
        path: ApiPaths.SmsContentsSendList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakLanguages
     * @name SpeakLanguagesDeleteDelete
     * @request DELETE:/api/SpeakLanguages/Delete/{id}
     * @secure
     */
    speakLanguagesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ISpeakLanguage, any>({
        path: ApiPaths.SpeakLanguagesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakLanguages
     * @name SpeakLanguagesGetAllDynamicList
     * @request GET:/api/SpeakLanguages/GetAllDynamic
     * @secure
     */
    speakLanguagesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ISpeakLanguageDynamicResponse, any>({
        path: ApiPaths.SpeakLanguagesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakLanguages
     * @name SpeakLanguagesCreateCreate
     * @request POST:/api/SpeakLanguages/Create
     * @secure
     */
    speakLanguagesCreateCreate: (data: ISpeakLanguage, params: RequestParams = {}) =>
      this.request<ISpeakLanguage, any>({
        path: ApiPaths.SpeakLanguagesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SpeakLanguages
     * @name SpeakLanguagesPatchPartialUpdate
     * @request PATCH:/api/SpeakLanguages/Patch/{id}
     * @secure
     */
    speakLanguagesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<ISpeakLanguage, any>({
        path: ApiPaths.SpeakLanguagesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SponsorCompanies
     * @name SponsorCompaniesDeleteDelete
     * @request DELETE:/api/SponsorCompanies/Delete/{id}
     * @secure
     */
    sponsorCompaniesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ISponsorCompany, any>({
        path: ApiPaths.SponsorCompaniesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SponsorCompanies
     * @name SponsorCompaniesGetAllDynamicList
     * @request GET:/api/SponsorCompanies/GetAllDynamic
     * @secure
     */
    sponsorCompaniesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ISponsorCompanyDynamicResponse, any>({
        path: ApiPaths.SponsorCompaniesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SponsorCompanies
     * @name SponsorCompaniesCreateCreate
     * @request POST:/api/SponsorCompanies/Create
     * @secure
     */
    sponsorCompaniesCreateCreate: (data: ISponsorCompany, params: RequestParams = {}) =>
      this.request<ISponsorCompany, any>({
        path: ApiPaths.SponsorCompaniesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SponsorCompanies
     * @name SponsorCompaniesPatchPartialUpdate
     * @request PATCH:/api/SponsorCompanies/Patch/{id}
     * @secure
     */
    sponsorCompaniesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<ISponsorCompany, any>({
        path: ApiPaths.SponsorCompaniesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyOptions
     * @name SurveyOptionsDeleteDelete
     * @request DELETE:/api/SurveyOptions/Delete/{id}
     * @secure
     */
    surveyOptionsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ISurveyOption, any>({
        path: ApiPaths.SurveyOptionsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyOptions
     * @name SurveyOptionsGetAllDynamicList
     * @request GET:/api/SurveyOptions/GetAllDynamic
     * @secure
     */
    surveyOptionsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ISurveyOptionDynamicResponse, any>({
        path: ApiPaths.SurveyOptionsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyOptions
     * @name SurveyOptionsCreateCreate
     * @request POST:/api/SurveyOptions/Create
     * @secure
     */
    surveyOptionsCreateCreate: (data: ISurveyOption, params: RequestParams = {}) =>
      this.request<ISurveyOption, any>({
        path: ApiPaths.SurveyOptionsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyOptions
     * @name SurveyOptionsPatchPartialUpdate
     * @request PATCH:/api/SurveyOptions/Patch/{id}
     * @secure
     */
    surveyOptionsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ISurveyOption, any>({
        path: ApiPaths.SurveyOptionsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name SurveysDeleteDelete
     * @request DELETE:/api/Surveys/Delete/{id}
     * @secure
     */
    surveysDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ISurvey, any>({
        path: ApiPaths.SurveysDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name SurveysGetAllDynamicList
     * @request GET:/api/Surveys/GetAllDynamic
     * @secure
     */
    surveysGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ISurveyDynamicResponse, any>({
        path: ApiPaths.SurveysGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name SurveysCreateCreate
     * @request POST:/api/Surveys/Create
     * @secure
     */
    surveysCreateCreate: (data: ISurvey, params: RequestParams = {}) =>
      this.request<ISurvey, any>({
        path: ApiPaths.SurveysCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Surveys
     * @name SurveysPatchPartialUpdate
     * @request PATCH:/api/Surveys/Patch/{id}
     * @secure
     */
    surveysPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ISurvey, any>({
        path: ApiPaths.SurveysPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyTags
     * @name SurveyTagsDeleteDelete
     * @request DELETE:/api/SurveyTags/Delete/{id}
     * @secure
     */
    surveyTagsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ISurveyTag, any>({
        path: ApiPaths.SurveyTagsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyTags
     * @name SurveyTagsGetAllDynamicList
     * @request GET:/api/SurveyTags/GetAllDynamic
     * @secure
     */
    surveyTagsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ISurveyTagDynamicResponse, any>({
        path: ApiPaths.SurveyTagsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyTags
     * @name SurveyTagsCreateCreate
     * @request POST:/api/SurveyTags/Create
     * @secure
     */
    surveyTagsCreateCreate: (data: ISurveyTag, params: RequestParams = {}) =>
      this.request<ISurveyTag, any>({
        path: ApiPaths.SurveyTagsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyTags
     * @name SurveyTagsPatchPartialUpdate
     * @request PATCH:/api/SurveyTags/Patch/{id}
     * @secure
     */
    surveyTagsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ISurveyTag, any>({
        path: ApiPaths.SurveyTagsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsDeleteDelete
     * @request DELETE:/api/Tags/Delete/{id}
     * @secure
     */
    tagsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<ITag, any>({
        path: ApiPaths.TagsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsGetAllDynamicList
     * @request GET:/api/Tags/GetAllDynamic
     * @secure
     */
    tagsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ITagDynamicResponse, any>({
        path: ApiPaths.TagsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsCreateCreate
     * @request POST:/api/Tags/Create
     * @secure
     */
    tagsCreateCreate: (data: ITag, params: RequestParams = {}) =>
      this.request<ITag, any>({
        path: ApiPaths.TagsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Tags
     * @name TagsPatchPartialUpdate
     * @request PATCH:/api/Tags/Patch/{id}
     * @secure
     */
    tagsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<ITag, any>({
        path: ApiPaths.TagsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfilePermissions
     * @name UserCrmProfilePermissionsDeleteDelete
     * @request DELETE:/api/UserCrmProfilePermissions/Delete/{id}
     * @secure
     */
    userCrmProfilePermissionsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserCrmProfilePermission, any>({
        path: ApiPaths.UserCrmProfilePermissionsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfilePermissions
     * @name UserCrmProfilePermissionsGetAllDynamicList
     * @request GET:/api/UserCrmProfilePermissions/GetAllDynamic
     * @secure
     */
    userCrmProfilePermissionsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserCrmProfilePermissionDynamicResponse, any>({
        path: ApiPaths.UserCrmProfilePermissionsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfilePermissions
     * @name UserCrmProfilePermissionsCreateCreate
     * @request POST:/api/UserCrmProfilePermissions/Create
     * @secure
     */
    userCrmProfilePermissionsCreateCreate: (
      data: IUserCrmProfilePermission,
      params: RequestParams = {},
    ) =>
      this.request<IUserCrmProfilePermission, any>({
        path: ApiPaths.UserCrmProfilePermissionsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfilePermissions
     * @name UserCrmProfilePermissionsPatchPartialUpdate
     * @request PATCH:/api/UserCrmProfilePermissions/Patch/{id}
     * @secure
     */
    userCrmProfilePermissionsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserCrmProfilePermission, any>({
        path: ApiPaths.UserCrmProfilePermissionsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfiles
     * @name UserCrmProfilesDeleteDelete
     * @request DELETE:/api/UserCrmProfiles/Delete/{id}
     * @secure
     */
    userCrmProfilesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserCrmProfile, any>({
        path: ApiPaths.UserCrmProfilesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfiles
     * @name UserCrmProfilesGetAllDynamicList
     * @request GET:/api/UserCrmProfiles/GetAllDynamic
     * @secure
     */
    userCrmProfilesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserCrmProfileDynamicResponse, any>({
        path: ApiPaths.UserCrmProfilesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfiles
     * @name UserCrmProfilesCreateCreate
     * @request POST:/api/UserCrmProfiles/Create
     * @secure
     */
    userCrmProfilesCreateCreate: (data: IUserCrmProfile, params: RequestParams = {}) =>
      this.request<IUserCrmProfile, any>({
        path: ApiPaths.UserCrmProfilesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserCrmProfiles
     * @name UserCrmProfilesPatchPartialUpdate
     * @request PATCH:/api/UserCrmProfiles/Patch/{id}
     * @secure
     */
    userCrmProfilesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserCrmProfile, any>({
        path: ApiPaths.UserCrmProfilesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileArticles
     * @name UserExpertProfileArticlesDeleteDelete
     * @request DELETE:/api/UserExpertProfileArticles/Delete/{id}
     * @secure
     */
    userExpertProfileArticlesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfileArticle, any>({
        path: ApiPaths.UserExpertProfileArticlesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileArticles
     * @name UserExpertProfileArticlesGetAllDynamicList
     * @request GET:/api/UserExpertProfileArticles/GetAllDynamic
     * @secure
     */
    userExpertProfileArticlesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileArticleDynamicResponse, any>({
        path: ApiPaths.UserExpertProfileArticlesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileArticles
     * @name UserExpertProfileArticlesCreateCreate
     * @request POST:/api/UserExpertProfileArticles/Create
     * @secure
     */
    userExpertProfileArticlesCreateCreate: (
      data: IUserExpertProfileArticle,
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileArticle, any>({
        path: ApiPaths.UserExpertProfileArticlesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileArticles
     * @name UserExpertProfileArticlesPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfileArticles/Patch/{id}
     * @secure
     */
    userExpertProfileArticlesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileArticle, any>({
        path: ApiPaths.UserExpertProfileArticlesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileFollows
     * @name UserExpertProfileFollowsDeleteDelete
     * @request DELETE:/api/UserExpertProfileFollows/Delete/{id}
     * @secure
     */
    userExpertProfileFollowsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfileFollow, any>({
        path: ApiPaths.UserExpertProfileFollowsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileFollows
     * @name UserExpertProfileFollowsGetAllDynamicList
     * @request GET:/api/UserExpertProfileFollows/GetAllDynamic
     * @secure
     */
    userExpertProfileFollowsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileFollowDynamicResponse, any>({
        path: ApiPaths.UserExpertProfileFollowsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileFollows
     * @name UserExpertProfileFollowsCreateCreate
     * @request POST:/api/UserExpertProfileFollows/Create
     * @secure
     */
    userExpertProfileFollowsCreateCreate: (
      data: IUserExpertProfileFollow,
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileFollow, any>({
        path: ApiPaths.UserExpertProfileFollowsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileFollows
     * @name UserExpertProfileFollowsPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfileFollows/Patch/{id}
     * @secure
     */
    userExpertProfileFollowsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileFollow, any>({
        path: ApiPaths.UserExpertProfileFollowsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfiles
     * @name UserExpertProfilesDeleteDelete
     * @request DELETE:/api/UserExpertProfiles/Delete/{id}
     * @secure
     */
    userExpertProfilesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfile, any>({
        path: ApiPaths.UserExpertProfilesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfiles
     * @name UserExpertProfilesGetAllDynamicList
     * @request GET:/api/UserExpertProfiles/GetAllDynamic
     * @secure
     */
    userExpertProfilesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileDynamicResponse, any>({
        path: ApiPaths.UserExpertProfilesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfiles
     * @name UserExpertProfilesCreateCreate
     * @request POST:/api/UserExpertProfiles/Create
     * @secure
     */
    userExpertProfilesCreateCreate: (data: IUserExpertProfile, params: RequestParams = {}) =>
      this.request<IUserExpertProfile, any>({
        path: ApiPaths.UserExpertProfilesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfiles
     * @name UserExpertProfilesPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfiles/Patch/{id}
     * @secure
     */
    userExpertProfilesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfile, any>({
        path: ApiPaths.UserExpertProfilesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSpeakLanguages
     * @name UserExpertProfileSpeakLanguagesDeleteDelete
     * @request DELETE:/api/UserExpertProfileSpeakLanguages/Delete/{id}
     * @secure
     */
    userExpertProfileSpeakLanguagesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfileSpeakLanguage, any>({
        path: ApiPaths.UserExpertProfileSpeakLanguagesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSpeakLanguages
     * @name UserExpertProfileSpeakLanguagesGetAllDynamicList
     * @request GET:/api/UserExpertProfileSpeakLanguages/GetAllDynamic
     * @secure
     */
    userExpertProfileSpeakLanguagesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileSpeakLanguageDynamicResponse, any>({
        path: ApiPaths.UserExpertProfileSpeakLanguagesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSpeakLanguages
     * @name UserExpertProfileSpeakLanguagesCreateCreate
     * @request POST:/api/UserExpertProfileSpeakLanguages/Create
     * @secure
     */
    userExpertProfileSpeakLanguagesCreateCreate: (
      data: IUserExpertProfileSpeakLanguage,
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileSpeakLanguage, any>({
        path: ApiPaths.UserExpertProfileSpeakLanguagesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSpeakLanguages
     * @name UserExpertProfileSpeakLanguagesPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfileSpeakLanguages/Patch/{id}
     * @secure
     */
    userExpertProfileSpeakLanguagesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileSpeakLanguage, any>({
        path: ApiPaths.UserExpertProfileSpeakLanguagesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSurveys
     * @name UserExpertProfileSurveysDeleteDelete
     * @request DELETE:/api/UserExpertProfileSurveys/Delete/{id}
     * @secure
     */
    userExpertProfileSurveysDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfileSurvey, any>({
        path: ApiPaths.UserExpertProfileSurveysDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSurveys
     * @name UserExpertProfileSurveysGetAllDynamicList
     * @request GET:/api/UserExpertProfileSurveys/GetAllDynamic
     * @secure
     */
    userExpertProfileSurveysGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileSurveyDynamicResponse, any>({
        path: ApiPaths.UserExpertProfileSurveysGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSurveys
     * @name UserExpertProfileSurveysCreateCreate
     * @request POST:/api/UserExpertProfileSurveys/Create
     * @secure
     */
    userExpertProfileSurveysCreateCreate: (
      data: IUserExpertProfileSurvey,
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileSurvey, any>({
        path: ApiPaths.UserExpertProfileSurveysCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileSurveys
     * @name UserExpertProfileSurveysPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfileSurveys/Patch/{id}
     * @secure
     */
    userExpertProfileSurveysPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileSurvey, any>({
        path: ApiPaths.UserExpertProfileSurveysPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileTags
     * @name UserExpertProfileTagsDeleteDelete
     * @request DELETE:/api/UserExpertProfileTags/Delete/{id}
     * @secure
     */
    userExpertProfileTagsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfileTag, any>({
        path: ApiPaths.UserExpertProfileTagsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileTags
     * @name UserExpertProfileTagsGetAllDynamicList
     * @request GET:/api/UserExpertProfileTags/GetAllDynamic
     * @secure
     */
    userExpertProfileTagsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileTagDynamicResponse, any>({
        path: ApiPaths.UserExpertProfileTagsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileTags
     * @name UserExpertProfileTagsCreateCreate
     * @request POST:/api/UserExpertProfileTags/Create
     * @secure
     */
    userExpertProfileTagsCreateCreate: (data: IUserExpertProfileTag, params: RequestParams = {}) =>
      this.request<IUserExpertProfileTag, any>({
        path: ApiPaths.UserExpertProfileTagsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileTags
     * @name UserExpertProfileTagsPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfileTags/Patch/{id}
     * @secure
     */
    userExpertProfileTagsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileTag, any>({
        path: ApiPaths.UserExpertProfileTagsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileViews
     * @name UserExpertProfileViewsDeleteDelete
     * @request DELETE:/api/UserExpertProfileViews/Delete/{id}
     * @secure
     */
    userExpertProfileViewsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfileView, any>({
        path: ApiPaths.UserExpertProfileViewsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileViews
     * @name UserExpertProfileViewsGetAllDynamicList
     * @request GET:/api/UserExpertProfileViews/GetAllDynamic
     * @secure
     */
    userExpertProfileViewsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileViewDynamicResponse, any>({
        path: ApiPaths.UserExpertProfileViewsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileViews
     * @name UserExpertProfileViewsCreateCreate
     * @request POST:/api/UserExpertProfileViews/Create
     * @secure
     */
    userExpertProfileViewsCreateCreate: (
      data: IUserExpertProfileView,
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileView, any>({
        path: ApiPaths.UserExpertProfileViewsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileViews
     * @name UserExpertProfileViewsPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfileViews/Patch/{id}
     * @secure
     */
    userExpertProfileViewsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileView, any>({
        path: ApiPaths.UserExpertProfileViewsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileVirtualEvents
     * @name UserExpertProfileVirtualEventsDeleteDelete
     * @request DELETE:/api/UserExpertProfileVirtualEvents/Delete/{id}
     * @secure
     */
    userExpertProfileVirtualEventsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertProfileVirtualEvent, any>({
        path: ApiPaths.UserExpertProfileVirtualEventsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileVirtualEvents
     * @name UserExpertProfileVirtualEventsGetAllDynamicList
     * @request GET:/api/UserExpertProfileVirtualEvents/GetAllDynamic
     * @secure
     */
    userExpertProfileVirtualEventsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileVirtualEventDynamicResponse, any>({
        path: ApiPaths.UserExpertProfileVirtualEventsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileVirtualEvents
     * @name UserExpertProfileVirtualEventsCreateCreate
     * @request POST:/api/UserExpertProfileVirtualEvents/Create
     * @secure
     */
    userExpertProfileVirtualEventsCreateCreate: (
      data: IUserExpertProfileVirtualEvent,
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileVirtualEvent, any>({
        path: ApiPaths.UserExpertProfileVirtualEventsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertProfileVirtualEvents
     * @name UserExpertProfileVirtualEventsPatchPartialUpdate
     * @request PATCH:/api/UserExpertProfileVirtualEvents/Patch/{id}
     * @secure
     */
    userExpertProfileVirtualEventsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertProfileVirtualEvent, any>({
        path: ApiPaths.UserExpertProfileVirtualEventsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertStatuses
     * @name UserExpertStatusesDeleteDelete
     * @request DELETE:/api/UserExpertStatuses/Delete/{id}
     * @secure
     */
    userExpertStatusesDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IUserExpertStatus, any>({
        path: ApiPaths.UserExpertStatusesDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertStatuses
     * @name UserExpertStatusesGetAllDynamicList
     * @request GET:/api/UserExpertStatuses/GetAllDynamic
     * @secure
     */
    userExpertStatusesGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertStatusDynamicResponse, any>({
        path: ApiPaths.UserExpertStatusesGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertStatuses
     * @name UserExpertStatusesCreateCreate
     * @request POST:/api/UserExpertStatuses/Create
     * @secure
     */
    userExpertStatusesCreateCreate: (data: IUserExpertStatus, params: RequestParams = {}) =>
      this.request<IUserExpertStatus, any>({
        path: ApiPaths.UserExpertStatusesCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserExpertStatuses
     * @name UserExpertStatusesPatchPartialUpdate
     * @request PATCH:/api/UserExpertStatuses/Patch/{id}
     * @secure
     */
    userExpertStatusesPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IUserExpertStatus, any>({
        path: ApiPaths.UserExpertStatusesPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEvents
     * @name VirtualEventsDeleteDelete
     * @request DELETE:/api/VirtualEvents/Delete/{id}
     * @secure
     */
    virtualEventsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IVirtualEvent, any>({
        path: ApiPaths.VirtualEventsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEvents
     * @name VirtualEventsGetAllDynamicList
     * @request GET:/api/VirtualEvents/GetAllDynamic
     * @secure
     */
    virtualEventsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IVirtualEventDynamicResponse, any>({
        path: ApiPaths.VirtualEventsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEvents
     * @name VirtualEventsCreateCreate
     * @request POST:/api/VirtualEvents/Create
     * @secure
     */
    virtualEventsCreateCreate: (data: IVirtualEvent, params: RequestParams = {}) =>
      this.request<IVirtualEvent, any>({
        path: ApiPaths.VirtualEventsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEvents
     * @name VirtualEventsPatchPartialUpdate
     * @request PATCH:/api/VirtualEvents/Patch/{id}
     * @secure
     */
    virtualEventsPatchPartialUpdate: (id: string, data: IOperation[], params: RequestParams = {}) =>
      this.request<IVirtualEvent, any>({
        path: ApiPaths.VirtualEventsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEventTags
     * @name VirtualEventTagsDeleteDelete
     * @request DELETE:/api/VirtualEventTags/Delete/{id}
     * @secure
     */
    virtualEventTagsDeleteDelete: (id: string, params: RequestParams = {}) =>
      this.request<IVirtualEventTag, any>({
        path: ApiPaths.VirtualEventTagsDeleteDelete(id),
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEventTags
     * @name VirtualEventTagsGetAllDynamicList
     * @request GET:/api/VirtualEventTags/GetAllDynamic
     * @secure
     */
    virtualEventTagsGetAllDynamicList: (
      query?: {
        Select?: string;
        Filter?: string;
        OrderBy?: string;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        Skip?: number;
        Count?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<IVirtualEventTagDynamicResponse, any>({
        path: ApiPaths.VirtualEventTagsGetAllDynamicList,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEventTags
     * @name VirtualEventTagsCreateCreate
     * @request POST:/api/VirtualEventTags/Create
     * @secure
     */
    virtualEventTagsCreateCreate: (data: IVirtualEventTag, params: RequestParams = {}) =>
      this.request<IVirtualEventTag, any>({
        path: ApiPaths.VirtualEventTagsCreateCreate,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags VirtualEventTags
     * @name VirtualEventTagsPatchPartialUpdate
     * @request PATCH:/api/VirtualEventTags/Patch/{id}
     * @secure
     */
    virtualEventTagsPatchPartialUpdate: (
      id: string,
      data: IOperation[],
      params: RequestParams = {},
    ) =>
      this.request<IVirtualEventTag, any>({
        path: ApiPaths.VirtualEventTagsPatchPartialUpdate(id),
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
